import React from "react";
import DataTable from "../../../../components/DataTable";


const ROIIncomeTable = ({data}) => {
  const columns = [
    { id: "sn", label: "S.N", minWidth: 20 },
    { id: "packages", label: "Package", minWidth: 100 },
    {
      id: "date",
      label: "Date",
      minWidth: 120,
    },
    {
      id: "roi_per_day",
      label: "ROI Per Day",
      minWidth: 110,
    },
    {
      id: "amount",
      label: "Amount",
      minWidth: 80,
    },
    {
      id: "total_amount",
      label: "Total Amount",
      minWidth: 110,
    },
    {
      id: "transaction_id",
      label: "Transaction ID",
      minWidth: 100,
    },
  ];

  function createData(
    sn,
    packages,
    date,
    roi_per_day,
    amount,
    total_amount,
    transaction_id
  ) {
    return {
      sn,
      packages,
      date,
      roi_per_day,
      amount,
      total_amount,
      transaction_id,
    };
  }
  // console.log(data);
  const rows = data?.map((d, i) =>
    createData(
      i + 1,
      "$" + d.packages,
      new Date(d.date).toDateString(),
      d.roi_per_day+"%",
      "$" +parseFloat(d?.amount).toFixed(3),
      "$" +parseFloat(d?.total_amount).toFixed(3),
      d.transaction_id
    )
  );
  // console.log(data);
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default ROIIncomeTable;
